module.exports = __webpack_public_path__ + "static/media/no-avatar.1527a4e3.svg";